export type LegendType = 'salesAmount' | 'operatingIncome' | 'netIncome';

interface LegendList {
  id: string;
  type: LegendType;
}

export const LEGEND_LIST: LegendList[] = [
  {
    id: '매출액',
    type: 'salesAmount',
  },
  {
    id: '영업이익',
    type: 'operatingIncome',
  },
  {
    id: '당기순이익',
    type: 'netIncome',
  },
];
